import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tippy from '@tippy.js/react';
import { events, SEARCH_MESSAGES } from '@/utils/KeyboardShortcuts';
import cssStyles from './AppElement.css';
import badgeStyles from './Badge.css';

class AppElement extends PureComponent {
  static propTypes = {
    appInfo: PropTypes.object.isRequired,
    category: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    isSelected: PropTypes.bool,
    hasBadge: PropTypes.bool,
  };

  static defaultProps = {
    isSelected: false,
    hasBadge: false,
  };

  onAppClick = () => {
    const { appInfo, onClick } = this.props;
    onClick(appInfo);
  };

  render() {
    const { appInfo, category, isSelected, hasBadge } = this.props;
    const { icon, name, description } = appInfo;
    const label = appInfo[category].label || name;
    let details = appInfo[category].description || description;
    if (name === 'Search') {
      details = `${details} (${events[SEARCH_MESSAGES].shortcutString})`;
    }
    const style = {
      WebkitMask: `url(${icon}?CORS=1) 0px 0px / cover no-repeat`,
    };
    const { id, properties: { backgroundColor = '#0abe51' } = {} } =
      appInfo || {};
    return (
      <Tippy maxWidth={200} content={details} arrow theme='bootstrap'>
        <div
          style={
            isSelected
              ? {
                  backgroundColor,
                }
              : {}
          }
          role='button'
          id={id}
          tabIndex={0}
          onKeyDown={() => {}}
          className={classNames(cssStyles.appElement, {
            [cssStyles.selected]: isSelected,
            [badgeStyles.badge]: hasBadge,
            'badge-element': hasBadge,
          })}
          onClick={this.onAppClick}
        >
          <div className={cssStyles.icon} style={style} />
          <div className={cssStyles.appName}>{label}</div>
        </div>
      </Tippy>
    );
  }
}

export default AppElement;



// WEBPACK FOOTER //
// ./src/components/appList/AppElement.js